import { Helper } from '../../Helper';
export class CreatePropertyObjectHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            const obj = sb.scope.addUnique();
            const pobj = sb.scope.addUnique();
            sb.emitOp(node, 'DUP');
            sb.scope.set(sb, node, options, pobj);
            sb.emitHelper(node, options, sb.helpers.createObject);
            sb.emitOp(node, 'TUCK');
            sb.scope.set(sb, node, options, obj);
            sb.emitOp(node, 'KEYS');
            sb.emitHelper(node, options, sb.helpers.arrForEach({
                each: () => {
                    sb.scope.get(sb, node, options, obj);
                    sb.scope.get(sb, node, options, pobj);
                    sb.emitOp(node, 'ROT');
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'PICKITEM');
                    sb.emitHelper(node, options, sb.helpers.setDataPropertyObjectProperty);
                },
            }));
        }
    }
}

//# sourceMappingURL=CreatePropertyObjectHelper.js.map
